import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import {fade} from '@material-ui/core/styles/colorManipulator';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    borderColor: 'lightgray',
    borderWidth: '1px',
    borderRadius: 0,
    borderStyle: 'solid',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },

  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    height: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit * 5,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 5,
    transition: theme.transitions.create('width'),
    fontFamily: 'PT Sans Narrow',
    fontSize: '17px',
    height: '100%',
    [theme.breakpoints.up('md')]: {},

  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  searchButton: {
    fontFamily: 'PT Sans Narrow',
    fontSize: '17px',
    height: '100%',
    width: '18%',
    color: '#fff',
    backgroundColor: '#76b5b8',
    '&:hover': {
      backgroundColor: fade('#76b5b8', 0.75),
    },
    borderRadius: 0
  },
  resetMinHeight: {
    minHeight: 0,
    height: '100%'
  },
  toolbarReset: {
    width:'100%',
    paddingLeft: 0,
    paddingRight: 0
  },
  backGround: {
    backgroundColor: 'transparent',
    color: 'inherit',
    height: '40px',
    border: null,
    boxShadow: 'none'
  }
});

class SearchBar extends React.Component {
  state = {
    anchorEl: null,
    mobileMoreAnchorEl: null,
    strSearch: null
  };
  setSearchRequest = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(this.state.strSearch)
    } else {
      return false;
    }
  }
  setValueSearch = (e) => {
    this.props.onChange(e.target.value)
  };

  render () {
    const { classes, placeholderInput, textBtn }  = this.props;
    return (
        <AppBar position="static" className={ classes.backGround }>
          <Toolbar className={ classes.toolbarReset } classes={ { root: classes.resetMinHeight } }>
            <div className={ classes.search }>
              <InputBase
                placeholder={ placeholderInput }
                onChange={ this.setValueSearch }
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                } }
              />
            </div>
          </Toolbar>
        </AppBar>
    );
  }
}

SearchBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchBar);



// WEBPACK FOOTER //
// ./assets/src/js/components/controls/SearchBar.jsx